// src/components/Service/hooks/serviceHooks.js

import { toast } from "react-toastify";
import { saveServiceRequest, saveCampusTimeRequest, saveServiceGalleryRequest,deleteServiceRequest ,  updateServiceRequest,
    updateCampusTimeRequest,
    updateServiceGalleryRequest,} from "../../../store/Service/servicesActions";
import {saveServiceVideoRequest} from "../../../store/ServiceVideo/serviceVideosActions"
import { fetchChurchesRequest } from "../../../store/Churches/actions";
import { useDispatch } from "react-redux";
import { useState } from "react";

// ===== Constants =====
export const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const meetingTimes = [
"12:00 AM",
"01:00 AM",
"02:00 AM",
"03:00 AM",
"04:00 AM",
"05:00 AM",
"06:00 AM",
"07:00 AM",
"08:00 AM",
"09:00 AM",
"10:00 AM",
"11:00 AM",
"12:00 PM",
"01:00 PM",
"02:00 PM",
"03:00 PM",
"04:00 PM",
"05:00 PM",
"06:00 PM",
"07:00 PM",
"08:00 PM",
"09:00 PM",
"10:00 PM",
"11:00 PM"

];
export const demoCampusOptions = [
  { _id: "1", name: "Main Campus" },
  { _id: "2", name: "Downtown Campus" },
  { _id: "3", name: "East Side Campus" },
];

export const fetchCampuses = (churches = [], churchId) => {
    try {
      let campuses = churches.flatMap((church) =>
        (church.campuses || []).map((campus) => ({
          _id: campus.campusObjId,
          name: campus.campusName || "—",
          churchId: church._id,
        }))
      );

      if (churchId) {
        campuses = campuses.filter((c) => c.churchId === churchId);
      }

      return campuses;
    } catch (error) {
            return [];
    }
  };


  export const fetchAllServices = (
    dispatch,
    page,
    limit,
    searchCriteria = {},
    callbackFn,
    churchId = ""
  ) => {

    dispatch(
      fetchChurchesRequest({
        apiPayloadRequest: {
          page: page,
          limit: limit,
          searchCriteria: searchCriteria,
          _id: churchId,
        },
        callback: (Data) => {
          if (Data?.type === 1) {
            // 🔹 Flatten all services from each church
            let allServices = (Data?.data ?? []).flatMap((church) =>
              (church.services ?? []).map((service) => ({
                ...service,
                churchId: church._id, // attach church id
                churchName: church.churchName,
              }))
            );

            // ✅ Filter by selected churchId if provided
            if (churchId) {
              allServices = allServices.filter(
                (service) => service.churchId === churchId
              );
            }

            if (callbackFn) {
              callbackFn({
                data: allServices,
                total: allServices.length, // or use Data?.totalRecords if available
              });
            }
          } else if (callbackFn) {
            callbackFn({ data: [], total: 0 });
          }
        },
      })
    );
  };






export const normalizeGallery = (payload) => {
  if (!payload) return { web: null, tablet: null, mobile: null };
  if (payload.web || payload.tablet || payload.mobile)
    return { web: payload.web || null, tablet: payload.tablet || null, mobile: payload.mobile || null };
  if (payload.target && payload.target.value) {
    const v = payload.target.value;
    return { web: v.web || null, tablet: v.tablet || null, mobile: v.mobile || null };
  }
  if (Array.isArray(payload)) {
    const first = payload[0] || null;
    return { web: first || null, tablet: null, mobile: null };
  }
  return { web: null, tablet: null, mobile: null };
};

export const coverGalleryToArray = (raw) => {
  if (!raw) return [];
  const normalized = normalizeGallery(raw);
  const arr = [];
  if (normalized.web) arr.push(normalized.web);
  if (normalized.tablet) arr.push(normalized.tablet);
  if (normalized.mobile) arr.push(normalized.mobile);
  if (Array.isArray(raw)) return raw;
  return arr;
};

// ===== Campus Functions =====
export const handleAddCampus = ({ campusSchedules, setSavedCampuses, setCampusSchedules, campusOptions }) => {
  const { campusId, day, startfrom, endsat, repeat } = campusSchedules;
  if (!campusId || !day || !startfrom || !endsat) {
    toast.error("Select campus, day, start time, and end time");
    return;
  }

  const campusName = campusOptions.find(c => c._id === campusId)?.name || "Unknown";

  setSavedCampuses(prev => {
    // Check if campus already exists -> update instead of add
    const existingIndex = prev.findIndex(c => c.campusId === campusId && c.day === day);
    if (existingIndex > -1) {
      const updated = [...prev];
      updated[existingIndex] = { ...updated[existingIndex], campusName, startfrom, endsat, repeat };
      return updated;
    }

    // Otherwise add new
    return [...prev, { campusId, campusName, day, startfrom, endsat, repeat }];
  });

  setCampusSchedules({ campusId: "", day: "", startfrom: "", endsat: "", repeat: "weekly" });
};


export const handleRemoveCampus = (index, setSavedCampuses) => {
  setSavedCampuses(prev => prev.filter((_, i) => i !== index));
};

export const handleSaveService = async ({
  dispatch,
  church,
  serviceName,
  serviceDescription,
  typeofService,
  savedCampuses,
  setServiceName,
  setServiceDescription,
  setTypeofService,
  setSavedCampuses,
  galleryData,
  onClose,
  rowData,
  setFormKey,
  thumbnailImage,
  isLive,
  isDefault,
  existingVideos = [], // Add this parameter for existing videos
}) => {

  if (!serviceName.trim()) return toast.error("Enter service name");
  if (!serviceDescription.trim()) return toast.error("Enter service description");

  // -------------------------------------------------------
  // 1️⃣ MAIN PAYLOAD (with conditional serviceObjId)
  // -------------------------------------------------------
  const apiPayloadRequest = {
    _id: church?._id,
    serviceName: serviceName.trim(),
    serviceTitle: serviceDescription.trim(),
    typeofService: typeofService.trim(),
  };

  // Add serviceObjId ONLY for update (rowData exists)
  if (rowData?.serviceObjId) {
    apiPayloadRequest.serviceObjId = rowData.serviceObjId;
  }

  const action = rowData ? updateServiceRequest : saveServiceRequest;

  // -------------------------------------------------------
  // 2️⃣ SAVE MAIN SERVICE
  // -------------------------------------------------------
  dispatch(
    action(apiPayloadRequest, async (response) => {

      if (!response || response.type !== 1) {
        return toast.error("Failed to save/update service");
      }

      // Get serviceObjId from different possible sources
      const serviceObjId =
        response.serviceObjId ||
        response.data?.serviceObjId ||
        rowData?.serviceObjId;

      if (!serviceObjId) {
        return toast.error("Missing service ID");
      }

      // -------------------------------------------------------
      // 3️⃣ SAVE ALL CAMPUSES
      // -------------------------------------------------------
      for (const campus of savedCampuses) {
        const campusPayload = {
          _id: church?._id,
          serviceObjId,
          campusandtimeObjId: campus.campusandtimeObjId || "",
          campusreffObjId: campus.campusId,
          day: campus.day,
          startfrom: campus.startfrom,
          endsat: campus.endsat,
          repeat: campus.repeat,
        };

        const campusAction = campus.campusandtimeObjId
          ? updateCampusTimeRequest
          : saveCampusTimeRequest;

        await new Promise((resolve) =>
          dispatch(
            campusAction(campusPayload, (res) => {
                            resolve(res);
            })
          )
        );
      }

      // -------------------------------------------------------
      // 4️⃣ HANDLE SERVICE GALLERY UPDATE
      // -------------------------------------------------------
      const galleryArray = Array.isArray(galleryData) ? galleryData : [];
      const existingGallery = rowData?.servicegallery || [];
      const firstCampus = savedCampuses[0];

      if (galleryArray.length > 0 && firstCampus) {
        const campusObjId = firstCampus.campusId;

        // Compare existing gallery with new gallery to find new items
        const existingGalleryIds = existingGallery.map(item => item.galleryObjId);
        const newGalleryItems = galleryArray.filter(item =>
          item.id && !existingGalleryIds.includes(item.id)
        );


        // Save only new gallery items
        for (const item of newGalleryItems) {
          if (!item.id) continue;

          const galleryPayload = {
            _id: church?._id,
            serviceObjId,
            galleryObjId: item.id,
            campusObjId,
            mobilesetting: item.mobilesetting || false,
            tabletsetting: item.tabletsetting || false,
            dashboardsetting: item.dashboardsetting || false,
            default: item.default || false,
          };

          await new Promise((resolve) =>
            dispatch(
              saveServiceGalleryRequest(galleryPayload, (res) => {
                                resolve(res);
              })
            )
          );
        }
      }


const videoIdsToSave = Array.isArray(thumbnailImage) ? thumbnailImage : [thumbnailImage].filter(Boolean);


if (videoIdsToSave.length > 0) {
  // Extract IDs of existing videos
  const existingVideoIds = existingVideos.map(video =>
    video.videoObjId ||
    video.id ||
    video.video?._id ||
    video.video?.id
  ).filter(id => id);


  // Filter out videos that already exist
  const newVideoIds = videoIdsToSave.filter(videoId => !existingVideoIds.includes(videoId));


  if (newVideoIds.length > 0) {
    // Save each new video
    for (const videoId of newVideoIds) {
      const videoPayload = {
        _id: church?._id,
        serviceObjId,
        videoObjId: videoId,
        live: isLive,
        default: isDefault
      };


      await new Promise((resolve) =>
        dispatch(
          saveServiceVideoRequest(videoPayload, (res) => {
                        if (res?.type === 1) {
                          } else {
                          }
            resolve(res);
          })
        )
      );
    }

    toast.success(`${newVideoIds.length} new video(s) added to service!`);
  } else {
        toast.info("All videos already associated with this service");
  }
} else if (existingVideos.length > 0) {
  // No new videos selected but we have existing videos
    toast.info("Using existing videos for this service");
}

      // -------------------------------------------------------
      // 6️⃣ DONE
      // -------------------------------------------------------
      toast.success(rowData ? "Service updated!" : "Service saved!");
      onClose?.();
      setFormKey((p) => p + 1);
      setServiceName("");
      setServiceDescription("");
      setTypeofService("services");
      setSavedCampuses([]);
    })
  );
};





export const handleDeleteService = (dispatch, churchId, serviceObjId, callback) => {
    if (!serviceObjId) return callback?.({ type: 0, error: "Missing serviceObjId" });
    if (!churchId) return callback?.({ type: 0, error: "Missing churchId" });

    const apiPayloadRequest = {
      _id: churchId, // ✅ dynamically passed from AllServices
      serviceObjId,
    };


    dispatch(
      deleteServiceRequest(apiPayloadRequest, (res) => {
                callback?.(res);
      })
    );
  };

  export const handleGallerySelect = ({ imageSet, setTempUrls, setGalleryData, existingGallery = [] }) => {
    const selectedArray = imageSet?.target?.value;

    if (!Array.isArray(selectedArray) || selectedArray.length === 0) return;


    // Filter out already existing gallery items
    const existingGalleryIds = existingGallery.map(item => item.galleryObjId);
    const newGalleryItems = selectedArray.filter(item =>
      item.id && !existingGalleryIds.includes(item.id)
    );

    // Only update with new items
    if (newGalleryItems.length > 0) {
      // Update temp URLs for the first new item only
      const first = newGalleryItems[0];
      setTempUrls({
        web: first?.web?.url || "",
        tablet: first?.tablet?.url || "",
        mobile: first?.mobile?.url || "",
      });

      // Combine existing gallery with new items
      const combinedGallery = [...existingGallery, ...newGalleryItems];
      setGalleryData(combinedGallery);

                } else {
      toast.info("All selected gallery items already exist for this service");
    }
  };


// ===== Utility Functions =====
export const handleSwapGalleryImage = (index, newType, setSavedServices) => {
  setSavedServices(prev => prev.map((s, i) => i !== index ? s : { ...s, activeGalleryType: newType }));
};

export const handleImageClick = (url, title, setSelectedImage) => {
  if (!url) return;
  setSelectedImage({ url, title });
};

export const closeModal = (setSelectedImage) => setSelectedImage(null);

export const removeCoverImage = (index, coverGalleryRaw, setCoverGalleryRaw) => {
  const arr = coverGalleryToArray(coverGalleryRaw);
  if (!arr.length) return;
  const newArr = arr.filter((_, i) => i !== index);
  setCoverGalleryRaw(newArr);
};

export const titleForType = (type) => {
  if (!type) return "";
  return type.charAt(0).toUpperCase() + type.slice(1);
};

// ===== AllServicesHooks =====
export const AllServicesHooks = () => {
    const dispatch = useDispatch();
    const [reloadData, setReloadData] = useState(false);
    return { reloadData, setReloadData, fetchAllServices, dispatch };
  };
